export const CANADA = 'Canada';
export const CANADA_PROVINCES = ['alberta', 'british columbia', 'ontario', 'quebec'];
